var _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteDivider(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "#FBFBFE",
    strokeWidth: 1,
    x1: 0,
    y1: 5,
    x2: 100,
    y2: 5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDivider);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAwIDEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8bGluZSBzdHJva2U9IiNGQkZCRkUiIHN0cm9rZS13aWR0aD0iMSIgeDE9IjAiIHkxPSI1IiB4Mj0iMTAwIiB5Mj0iNSIgLz4KPC9zdmc+";
export { ForwardRef as ReactComponent };